module.exports = __webpack_public_path__ + "static/img/pingjie3.23bb7f28.png";